import $http from '@/model/utils/http'
import storage from '@/model/utils/localStorage'

// 除登入请求，默认所有请求带 token
const initToken = (token, username, account) => {
  $http.defaults.headers.common['token'] = token
  $http.defaults.headers.common['Content-Type'] = 'application/json'
  storage.token = token
  storage.username = username
  storage.account = account
  return storage.token && storage.username && storage.account
}

// 登录
const login = formdata =>
  $http.post('/org/Login/index', formdata).then(async res => {
    const isOk = initToken(
      res.data.data.token,
      res.data.data.platformname,
      res.data.data.account
    )
    res.data = Object.assign(res.data, {
      tokenInitSuccess: isOk
    })
    return Promise.resolve(res)
  })

const editPwd = (params) =>
  $http.put('/org/member/resetPass', params)

export { initToken }
export default {
  login,
  editPwd
}
